import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

type WrapperFopDesktopScreenProps = {
  isFixed?: boolean
}

export const WrapperFopDesktopScreen = styled.div<WrapperFopDesktopScreenProps>`
  background-color: white;
  height: 70px;
  box-shadow: ${tokens.shadows.downSmall};
  position: ${props => (props.isFixed ? 'fixed' : 'sticky')};
  top: 0;
  z-index: ${props => (props.isFixed ? '9999' : '11')};
  width: ${props => (props.isFixed ? '100%' : 'auto')};
  left: ${props => (props.isFixed ? '0' : 'auto')};

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`
